webpackJsonp([230539012308250],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Checkbox = __webpack_require__(78);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	__webpack_require__(113);
	
	var _reactLoadingOverlay = __webpack_require__(30);
	
	var _reactLoadingOverlay2 = _interopRequireDefault(_reactLoadingOverlay);
	
	var _Help = __webpack_require__(32);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _jsCookie = __webpack_require__(42);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _NavigationUtils = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginATI = function (_React$Component) {
	  _inherits(LoginATI, _React$Component);
	
	  function LoginATI(props) {
	    _classCallCheck(this, LoginATI);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleUpdate = function (event) {
	      if (event.target.checked) {
	        _this.setState({ admin: true });
	      } else {
	        _this.setState({ admin: false });
	      }
	    };
	
	    _this.updateUsername = function (event) {
	      _this.setState({ userName: event.target.value });
	    };
	
	    _this.updatePassword = function (event) {
	      _this.setState({ password: event.target.value });
	    };
	
	    _this.postData = function (url) {
	      // Default options are marked with *
	      return fetch(url, {
	        method: "POST", // *GET, POST, PUT, DELETE, etc.
	        mode: "cors", // no-cors, cors, *same-origin
	        //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
	        //credentials: "same-origin", // include, *same-origin, omit
	        headers: {
	          //"Content-Type": "text/html",
	          //"Accept" : "text/html"//,
	          //  "Accept-Encoding": "gzip, deflate"
	          "Content-Type": "application/x-www-form-urlencoded"
	        },
	        body: "j_username=" + encodeURIComponent(_this.state.userName) + "&j_password=" + encodeURIComponent(_this.state.password) + "&portal=true"
	      }).then(function (response) {
	        return response.json();
	      }); // parses response to JSON
	    };
	
	    _this.postDataAgentAdmin = function (url) {
	      // Default options are marked with *
	      return fetch(url, {
	        method: "POST", // *GET, POST, PUT, DELETE, etc.
	        mode: "cors", // no-cors, cors, *same-origin
	        //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
	        //credentials: "same-origin", // include, *same-origin, omit
	        headers: {
	          //"Content-Type": "text/html",
	          //"Accept" : "text/html"//,
	          //  "Accept-Encoding": "gzip, deflate"
	          "Content-Type": "application/x-www-form-urlencoded"
	        },
	        body: "userName=" + _this.state.userName + "&password=" + _this.state.password
	      }).then(function (response) {
	        return response.json();
	      }); // parses response to JSON
	    };
	
	    _this.handleSubmit = function (event) {
	      if (_this.state.admin) {
	        _this.setState({ isActive: true });
	        event.preventDefault();
	        _this.setState({ isActive: true });
	        _this.postDataAgentAdmin("/agentadmin/login").then(function (data) {
	          // console.log("data: " + JSON.stringify(data));
	          var errorString = null;
	          var successValue = false;
	          if (data.errors != null && data.errors[0] != null) {
	            errorString = data.errors[0];
	          }
	          if (data.messageKey != null && data.messageKey === "success") {
	            successValue = true;
	          }
	          _this.setState({
	            errorMessage: errorString,
	            success: successValue,
	            redirect: "/agentadmin/agent",
	            isActive: successValue
	          });
	        });
	      } else {
	        event.preventDefault();
	        _this.setState({ isActive: true });
	        _this.postData("/wbe/CommandServlet?command=login&login=wbe").then(function (data) {
	          // console.log(JSON.stringify(data));
	          var redirCookie = _jsCookie2.default.get("ATIWBEDIRECT");
	          var redirectLink = data.data.redirect;
	          if (redirCookie) {
	            redirectLink = redirectLink + "/" + redirCookie;
	          }
	          _this.setState({
	            errorMessage: data.data.errorMessage,
	            success: data.data.success,
	            redirect: redirectLink,
	            isActive: data.data.success
	          });
	        });
	      }
	    };
	
	    _this.renderRedirect = function () {
	      if (_this.state.success) {
	        window.location.replace(_this.state.redirect);
	      }
	    };
	
	    _this.renderHelpLabel = function () {
	      if (_this.state.source === "index") {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "./help" },
	          _react2.default.createElement(
	            "svg",
	            {
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 15 15",
	              width: 15,
	              height: 15,
	              fill: "#E21E32",
	              style: { marginRight: 6 }
	            },
	            _react2.default.createElement("path", {
	              d: "M727.8 1042.6l-.7.4-.8.9.3.2.5-.5.1.1-.1.7-1.1 3.1-.2 1c0 .4.3.6.7.5l.7-.4.6-.7-.3-.3-.4.4-.1-.1.2-.7 1.1-3.1.2-1c-.1-.4-.3-.6-.7-.5zm1.5-1.5c-.2.4-.7.6-1.1.4-.4-.2-.6-.7-.4-1.1.2-.4.6-.5.9-.4.5.2.7.7.6 1.1zm-1.8 9.9a6.5 6.5 0 1 0 0-13 6.5 6.5 0 1 0 0 13m0 1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z",
	              transform: "translate(-720 -1037)"
	            })
	          ),
	          "Help?"
	        );
	      } else {
	        return _react2.default.createElement(
	          "a",
	          {
	            href: "#0",
	            className: "header-form__label",
	            onClick: function onClick() {
	              _this.toggleHelp();
	            }
	          },
	          _react2.default.createElement(
	            "svg",
	            {
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 15 15",
	              width: 15,
	              height: 15,
	              fill: "#E21E32",
	              style: { marginRight: 6 }
	            },
	            _react2.default.createElement("path", {
	              d: "M727.8 1042.6l-.7.4-.8.9.3.2.5-.5.1.1-.1.7-1.1 3.1-.2 1c0 .4.3.6.7.5l.7-.4.6-.7-.3-.3-.4.4-.1-.1.2-.7 1.1-3.1.2-1c-.1-.4-.3-.6-.7-.5zm1.5-1.5c-.2.4-.7.6-1.1.4-.4-.2-.6-.7-.4-1.1.2-.4.6-.5.9-.4.5.2.7.7.6 1.1zm-1.8 9.9a6.5 6.5 0 1 0 0-13 6.5 6.5 0 1 0 0 13m0 1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z",
	              transform: "translate(-720 -1037)"
	            })
	          ),
	          "Help?"
	        );
	      }
	    };
	
	    _this.displayHelp = function () {
	      if (_this.state.help === "show") {
	        return _react2.default.createElement(_Help2.default, { id: "help" });
	      }
	    };
	
	    _this.toggleHelp = function () {
	      if (_this.state.help === "show") {
	        _this.setState({ help: "hide" });
	      } else {
	        _this.setState({ help: "show" });
	      }
	    };
	
	    _this.rendorVertialLogin = function () {
	      var sessionCookie = _jsCookie2.default.get("ATIWBESESSION");
	      if (sessionCookie) {
	        return _this.renderATIConnectButton();
	      } else {
	        return _react2.default.createElement(
	          "div",
	          { style: { width: "100%" } },
	          _this.renderRedirect(),
	          _react2.default.createElement(
	            _reactLoadingOverlay2.default,
	            {
	              active: _this.state.isActive,
	              spinner: true,
	              text: "Loading..."
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { marginTop: 50, display: "flex", justifyContent: "center", alignContent: "center", alignItems: "flex-start", flexWrap: "wrap", backgroundColor: "rgba(0, 48, 78, .8)" } },
	              _react2.default.createElement(
	                "div",
	                { "class": "ws__lists", style: { marginTop: 35, paddingLeft: 70, paddingRight: 50, display: "inherit", height: "auto", flexBasis: "33%", flexGrow: 1 } },
	                _react2.default.createElement(
	                  "ul",
	                  { "class": "t-ul" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Access our industry leading booking platform where you can easily design your customer's next American road trip!"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Unbeatable rates - all products and services are directly contracted"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Discover ATI's curated Drive America packages - get ready to hit the road!"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { textAlign: "center", height: "auto", display: "inherit", flexShrink: 1, flexGrow: 1 } },
	                _react2.default.createElement(
	                  "form",
	                  {
	                    id: "wbe-login",
	                    action: _this.state.action,
	                    onSubmit: function onSubmit(event) {
	                      _this.handleSubmit(event);
	                    },
	                    method: "post",
	                    className: "header-form",
	                    style: { marginLeft: "auto", marginRight: "auto", height: "auto", backgroundColor: "transparent" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "alert-message c-div-error",
	                      style: { textAlign: "center" }
	                    },
	                    _this.state.errorMessage
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "c-div" },
	                    _react2.default.createElement("input", {
	                      id: "userName",
	                      name: "userName",
	                      placeholder: "Username...",
	                      className: "c-input header-form__input",
	                      tabIndex: "1",
	                      required: true,
	                      onChange: function onChange(event) {
	                        _this.updateUsername(event);
	                      }
	                    }),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("input", {
	                      id: "password",
	                      name: "password",
	                      type: "password",
	                      placeholder: "Password...",
	                      className: "c-input header-form__input",
	                      required: true,
	                      tabIndex: "2",
	                      onChange: function onChange(event) {
	                        _this.updatePassword(event);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "header-form__options header-form__options--1 t-label" },
	                      _react2.default.createElement(
	                        "label",
	                        { className: "header-form__label" },
	                        _react2.default.createElement(_Checkbox2.default, {
	                          id: "admin",
	                          name: "admin",
	                          onChange: function onChange(event) {
	                            _this.handleUpdate(event);
	                          }
	                        }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Admin"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "header-form__label",
	                          style: { whiteSpace: "nowrap" }
	                        },
	                        _react2.default.createElement(_Checkbox2.default, { name: "rememberme" }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Remember Me"
	                        )
	                      ),
	                      _this.renderHelpLabel()
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "header-form__options header-form__options--2" },
	                      _react2.default.createElement(
	                        "label",
	                        { className: "header-form__label header-form__link" },
	                        "Forgot your\xA0",
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: "/forgotUsername" },
	                          "username"
	                        ),
	                        "\xA0or\xA0",
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: "/forgotPassword" },
	                          "password"
	                        ),
	                        "\xA0?"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "submit",
	                        className: "c-btn c-btn--white header-form__btn",
	                        tabIndex: "3"
	                      },
	                      "Login",
	                      _react2.default.createElement(
	                        "svg",
	                        {
	                          viewBox: "0 0 30.595 12.238",
	                          width: "24",
	                          height: "11",
	                          fill: "currentColor",
	                          style: { marginLeft: 5 }
	                        },
	                        _react2.default.createElement(
	                          "g",
	                          { transform: "translate(-5 -22)" },
	                          _react2.default.createElement("path", {
	                            d: "M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z",
	                            transform: "translate(827 -1165.238)"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        id: "signupBtn",
	                        className: "c-btn header-form__btn",
	                        type: "button",
	                        onClick: function onClick(e) {
	                          _this.handleSignUp(e);
	                        }
	                      },
	                      "Sign Up"
	                    )
	                  )
	                ),
	                _this.displayHelp()
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "ws__lists", style: { marginTop: 35, paddingLeft: 70, paddingRight: 50, display: "inherit", height: "auto", flexBasis: "33%", flexGrow: 1 } },
	                _react2.default.createElement(
	                  "ul",
	                  { "class": "t-ul" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Book over 30,000 accommodation, attractions, transportation providers across North America"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Access to scarce inventory in and around America's National Parks"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Flexible booking terms and 24/7 U.S. based customer support "
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    };
	
	    _this.renderATIConnectButton = function () {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _this.renderRedirect(),
	        _react2.default.createElement(
	          _reactLoadingOverlay2.default,
	          { active: _this.state.isActive, spinner: true, text: "Loading..." },
	          _react2.default.createElement(
	            "div",
	            { className: "header-form", style: { marginTop: 50 } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/wbe",
	                className: "c-btn t-link mt30",
	                style: { margin: "auto" },
	                onClick: function onClick(event) {
	                  _this.handleClick(event);
	                }
	              },
	              "Back to ATI Connect"
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleClick = function (event) {
	      console.log("The link was clicked.");
	      _jsCookie2.default.remove("ATIWBESESSION", { path: "/" });
	    };
	
	    _this.renderMainLogin = function () {
	      var sessionCookie = _jsCookie2.default.get("ATIWBESESSION");
	      if (sessionCookie) {
	        return _this.renderATIConnectButton();
	      } else {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _this.renderRedirect(),
	          _react2.default.createElement(
	            _reactLoadingOverlay2.default,
	            {
	              active: _this.state.isActive,
	              spinner: true,
	              text: "Loading..."
	            },
	            _react2.default.createElement(
	              "form",
	              {
	                id: "wbe-login",
	                action: _this.state.action,
	                onSubmit: function onSubmit(event) {
	                  _this.handleSubmit(event);
	                },
	                method: "post",
	                className: "header-form",
	                style: { display: "inherit", height: "auto" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "alert-message c-div-error" },
	                _this.state.errorMessage
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-form__inner" },
	                _react2.default.createElement("input", {
	                  id: "userName",
	                  name: "userName",
	                  placeholder: "Username...",
	                  className: "c-input header-form__input",
	                  tabIndex: "1",
	                  required: true,
	                  onChange: function onChange(event) {
	                    _this.updateUsername(event);
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "header-form__options header-form__options--1 t-label" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "header-form__label" },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      id: "admin",
	                      name: "admin",
	                      onChange: function onChange(event) {
	                        _this.handleUpdate(event);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Admin"
	                    )
	                  ),
	                  _this.renderHelpLabel()
	                ),
	                _react2.default.createElement("input", {
	                  id: "password",
	                  name: "password",
	                  type: "password",
	                  placeholder: "Password...",
	                  className: "c-input header-form__input",
	                  required: true,
	                  tabIndex: "2",
	                  onChange: function onChange(event) {
	                    _this.updatePassword(event);
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "header-form__options header-form__options--2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "header-form__label",
	                      style: { whiteSpace: "nowrap" }
	                    },
	                    _react2.default.createElement(_Checkbox2.default, { name: "rememberme" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Remember Me"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "header-form__label header-form__link" },
	                    "Forgot your\xA0",
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/forgotUsername" },
	                      "username"
	                    ),
	                    "\xA0or\xA0",
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/forgotPassword" },
	                      "password"
	                    ),
	                    "\xA0?"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    className: "c-btn c-btn--white header-form__btn",
	                    tabIndex: "3"
	                  },
	                  "Login",
	                  _react2.default.createElement(
	                    "svg",
	                    {
	                      viewBox: "0 0 30.595 12.238",
	                      width: "24",
	                      height: "11",
	                      fill: "currentColor",
	                      style: { marginLeft: 5 }
	                    },
	                    _react2.default.createElement(
	                      "g",
	                      { transform: "translate(-5 -22)" },
	                      _react2.default.createElement("path", {
	                        d: "M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z",
	                        transform: "translate(827 -1165.238)"
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    id: "signupBtn",
	                    className: "c-btn header-form__btn main-signup-btn",
	                    type: "button",
	                    onClick: function onClick(e) {
	                      _this.handleSignUp(e);
	                    }
	                  },
	                  "Sign Up"
	                )
	              )
	            ),
	            _this.displayHelp()
	          )
	        );
	      }
	    };
	
	    _this.state = {
	      userName: "",
	      password: "",
	      admin: false,
	      rememberme: "",
	      action: "",
	      errorMessage: "",
	      success: false,
	      redirect: "",
	      isActive: false,
	      adminErrors: [],
	      adminState: "",
	      help: props.help,
	      source: props.source
	    };
	    return _this;
	  }
	
	  /**
	   * Handles the form signup event.
	   * @param {Event} event
	   */
	  LoginATI.prototype.handleSignUp = function handleSignUp(event) {
	    (0, _NavigationUtils.redirectToSignup)();
	  };
	
	  LoginATI.prototype.render = function render() {
	    if (this.state.source === "login") {
	      return this.rendorVertialLogin();
	    } else {
	      return this.renderMainLogin();
	    }
	  };
	
	  return LoginATI;
	}(_react2.default.Component);
	
	exports.default = LoginATI;
	module.exports = exports["default"];

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkbox = function Checkbox(props) {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement('input', { name: props.name, type: 'checkbox', className: 'c-checkbox__input', onChange: props.onChange }),
	    _react2.default.createElement('div', { className: 'c-checkbox__div' })
	  );
	};
	
	exports.default = Checkbox;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/login-image.b22b8e0d.jpg";

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	var _Login = __webpack_require__(77);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _loginImage = __webpack_require__(517);
	
	var _loginImage2 = _interopRequireDefault(_loginImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Login"
	    }),
	    _react2.default.createElement(
	      "header",
	      {
	        className: (0, _classnames2.default)('c-header', 'c-header--full', 't-context--dark', 'bg'),
	        style: { backgroundImage: "url(" + _loginImage2.default + ")" }
	      },
	      _react2.default.createElement(_Login2.default, { name: "atiLogin", source: "login" })
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.redirectToSignup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEST_DOMAIN = "test.americantours.com";
	
	var SIGNUP_TEST_URL = "https://signup-test.americantours.com";
	var SIGNUP_PROD_URL = "https://signup.americantours.com";
	
	var redirectToSignup = exports.redirectToSignup = function redirectToSignup() {
	  if (window.location.href.indexOf(TEST_DOMAIN) !== -1) {
	    window.location.replace(SIGNUP_TEST_URL);
	  } else {
	    window.location.replace(SIGNUP_PROD_URL);
	  }
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-login-js-42e85f63bb2a095e5f22.js